import { z } from 'zod';
/**
 * Phase 23 — subject-facing (caregiver + homecare) agreement read + accept
 * shapes. One shape set serves both personas (23-1); the URL persona segment
 * disambiguates which agreement type applies.
 *
 * Clickwrap acceptance (23-3): the subject submits the exact version they were
 * shown plus their typed legal name. A stale version 409s (cached-page guard,
 * 23-7). IP + user-agent are captured server-side (never client-supplied).
 */
// The agreement content + this subject's acceptance state, for the portal to
// render "review & accept" vs "accepted / download your copy".
export const AgreementStateResponseSchema = z.object({
    /** The current ACTIVE template the subject must accept. */
    currentVersion: z.string(),
    title: z.string(),
    bodyHtml: z.string(),
    /** Whether the subject's latest acceptance covers the current version
     *  (false when never accepted, or accepted a now-superseded version that
     *  requires re-acceptance, per 23-7). */
    accepted: z.boolean(),
    /** The version of the subject's most-recent acceptance (null if none). */
    acceptedVersion: z.string().nullable(),
    acceptedAt: z.string().datetime().nullable(),
    /** Signed-URL to the signed-PDF of the current acceptance, if rendered
     *  (23-4; null until the async render completes or if never accepted). */
    signedPdfUrl: z.string().nullable(),
});
export const AgreementAcceptRequestSchema = z.object({
    /** The version the subject was shown — must equal the current ACTIVE
     *  version or the accept 409s (23-7). */
    version: z.string().min(1),
    /** Typed legal name = the clickwrap signature (23-3). Trimmed, non-empty. */
    typedLegalName: z
        .string()
        .trim()
        .min(2, 'Enter your full legal name as your signature')
        .max(200),
});
export const AgreementAcceptResponseSchema = z.object({
    accepted: z.literal(true),
    version: z.string(),
    acceptedAt: z.string().datetime(),
    /** Present on the caregiver flow — whether this acceptance completed the
     *  ONBOARDING → ACTIVE gate and auto-flipped the caregiver to ACTIVE
     *  (23-5). Omitted / false for the homecare flow. */
    activated: z.boolean().optional(),
});
//# sourceMappingURL=agreement.schema.js.map